export default __webpack_public_path__ + "static/media/equipment.079ed458.jpg";